import React, { useState } from 'react'
import { Modal } from 'semantic-ui-react'
import { useCookies } from 'react-cookie'

import { useAppSelector } from 'redux/hooks'

import { Owner } from 'services/apiTypes/comment.types'
import { PLANESWALKER_LIST } from 'types/planeswalkers'

import { mulberry32 } from 'utils/random'

import WebsocketService from 'services/websocket.service'

import AvatarCircle from 'components/user/AvatarCircle'

import { encodeUsernameRoute } from 'utils/encoding'

import styles from './otherUsers.module.scss'

const MAX_SHOWN = 3

const OtherUsers = () => {
  const [showAll, setShowAll] = useState(false)

  const [{ tbId: userId }] = useCookies(['tbId'])
  const userGroup = useAppSelector(state => state.deck.userGroup)

  const users = Object.values(userGroup).sort((a, b) => (a.connectedAt > b.connectedAt ? -1 : 1))

  // userGroup should always have the user viewing the page (self) so if there's only 1 connected then don't render anything
  if (users.length < 2) return null

  return (
    <>
      <div className={styles.container}>
        {users.map((user, index) => {
          if (`${user.id}` === `${userId}`) return null
          if (index > MAX_SHOWN) return null
          if (user.id === WebsocketService.clientId) return null // anon users have no id, so we use their clientId instead

          if (index === MAX_SHOWN && users.length > MAX_SHOWN + 1)
            return (
              <div className={styles.avatarContainer} key={user.id}>
                <div className={styles.user} key={user.id}>
                  <button onClick={() => setShowAll(true)} className={styles.allUsers}>
                    +{users.length - MAX_SHOWN}
                  </button>
                </div>
              </div>
            )

          return <UserIcon user={user} key={user.id} />
        })}
      </div>

      <Modal size="tiny" open={showAll} onClose={() => setShowAll(false)} closeIcon>
        <Modal.Content>
          <div className={styles.connectedUsers}>
            <h3>Connected users</h3>
            {users.map(user => (
              <UserIcon user={user} key={user.id} includeUserName />
            ))}
          </div>
        </Modal.Content>
      </Modal>
    </>
  )
}

export default OtherUsers

const UserIcon = ({ user, includeUserName }: { user: Owner; includeUserName?: boolean }) => {
  const array = Object.keys(PLANESWALKER_LIST)
  const randomUsername = array[Math.floor(mulberry32(`${user.id}`) * array.length)]
  // @ts-ignore
  const randomAvatar = PLANESWALKER_LIST[randomUsername]

  if (!user.username) {
    return (
      <div className={styles.userInfo}>
        <div className={styles.avatarContainer} key={user.id}>
          <div title={`${randomUsername} (Anonymous)`} className={styles.user}>
            <img className={styles.image} src={randomAvatar} alt={`${randomUsername} avatar`} />
          </div>
        </div>
        {includeUserName && randomUsername}
      </div>
    )
  }

  return (
    <div className={styles.userInfo}>
      <div className={styles.avatarContainer} key={user.id}>
        <a
          href={`/u/${encodeUsernameRoute(user.username)}`}
          rel="noopener noreferrer"
          target="_blank"
          title={user.username}
          className={styles.user}>
          <AvatarCircle src={user.avatar} username={user.username} />
        </a>
      </div>
      {includeUserName && user.username}
    </div>
  )
}
